import { render, staticRenderFns } from "./form.modal.component.vue?vue&type=template&id=f8a374d2&scoped=true"
import script from "./form.modal.component.vue?vue&type=script&lang=js"
export * from "./form.modal.component.vue?vue&type=script&lang=js"
import style0 from "./form.modal.component.vue?vue&type=style&index=0&id=f8a374d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a374d2",
  null
  
)

export default component.exports